export interface EmailAddressWithAlias {
  address: string;
  alias?: string;
}

export enum EmailTemplateType {
  UserInvite = 0,
  ForgotPassword = 1,
  LockRequest = 2,
}

export interface EmailTemplateDto {
  emailTemplateType: EmailTemplateType;
  toAddresses: EmailAddressWithAlias[];
  ccAddresses: EmailAddressWithAlias[];
  bccAddresses: EmailAddressWithAlias[];
  replyToAddress?: EmailAddressWithAlias;
  fromAddress?: EmailAddressWithAlias;
  subject: string;
  htmlTemplate: string;
  reactSourceCode: string;
}

export interface EmailTemplateViewModel extends EmailTemplateDto {
  emailTemplateId: number;
}
